<template>
  <b-card no-body>
    <b-list-group flush>
      <b-list-group-item>
        <b-input-group>
          <b-input 
            v-model="jaar" 
            placeholder="Jaartal"
          />
          <b-button @click="jaarChanged">
            doorvoeren
          </b-button>
        </b-input-group>
      </b-list-group-item>
      <b-list-group-item 
        v-for="(h,index) in onderdeel.acties" 
        :key="index"
      >
        <b-check
          v-model="optionals[index]"
        >
          {{ h.naam }} start in {{ h.jaar || '...' }} + {{ h.cyclus }} = {{ h.jaar + h.cyclus }}
        </b-check>
      </b-list-group-item>
    </b-list-group>

    <b-card-footer>Op basis van de cyclus wordt het startjaar goed ingesteld</b-card-footer>
  </b-card>
</template>
<script>
export default {
  name: "ChecklistItemTypeA",
  props: {
    onderdeel: {
      type: Object,
      required: true
    },
    item: {
      type:Object,
      required: true
    }
  },
  data() {
    return {
      jaar: null,
      optionals: new Array(this.onderdeel.acties.length).fill(true),
    }
  },
  methods: {
    jaarChanged() {
      this.onderdeel.acties.forEach((h,index) => {
        if (this.optionals[index]) {
          h.jaar = this.jaar - h.cyclus
        }
      }) 
    }
  }
};
</script>
